<div class="modal-body vtr-modal-hardware-scan-rbs">

	<div class="row modal-information">
		<div *ngIf="devices; else deviceLoading">
			<h1 id="hwscan-rbs-modal-title" class="title" role="heading">{{ 'hardwareScan.recoverBadSectors.modalTitle' | translate }}</h1>
			<p id="hwscan-rbs-modal-description" class="description" role="text">{{ 'hardwareScan.recoverBadSectors.modalDescription' | translate }}</p>
		</div>

		<ng-template #deviceLoading>
			<h1 id="hwscan-rbs-modal-title" class="title without_description" role="heading">{{ 'hardwareScan.loadingDevices' | translate }}</h1>
		</ng-template>
	</div>

	<vtr-ui-hardware-list-checkbox
		[componentId]="'hwscan-rbs-devices'"
		[devices]="devices">
	</vtr-ui-hardware-list-checkbox>

	<div class="button-row">
		<vtr-material-button
			linkId="hwscan-rbs-run-selected-devices-btn"
			[label]="'hardwareScan.recoverBadSectors.title' | translate | uppercase"
			[isDisabled]="!isSelectedItem()"
			[tooltipText] ="'hardwareScan.recoverBadSectors.title' | translate"
			(buttonClick)="onClickRun()"
			heightSize="lg">
		</vtr-material-button>
	</div>

	<div class="btn-modal-close">
		<vtr-ui-close-button
			linkId="hwscan-rbs-scan-modal-close-btn"
			(clickClose)="closeModal()">
		</vtr-ui-close-button>
	</div>
</div>
